// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__117UM","content":"Consent_content__1Joz7","footer":"Consent_footer__2Ocpa"};